module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-uniforme-personalizado-768x591.929e298d.jpg";